// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"AuthorisedEmailsList__cardContainer___LkpuX"};